import { RouteObject } from 'react-router-dom';
import MainLayoutProvider from '../providers/MainLayoutProvider';
import AuthGuard from '../utils/route-guard/AuthGuard';
import MainLayout from '../layouts/MainLayout';
import { lazy, Suspense } from 'react';
import PhoenixLoader from '../components/common/PhoenixLoader';

const SettingsPage = lazy(() => import('pages/settings'));

const SettingsRoutes: RouteObject = {
  path: '/setting/',
  element: (
    <MainLayoutProvider>
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    </MainLayoutProvider>
  ),
  children: [
    {
      path: '',
      index: true,
      element: (
        <Suspense fallback={<PhoenixLoader />}>
          <SettingsPage />
        </Suspense>
      )
    }
  ]
};

export default SettingsRoutes;
